var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Treeable } from './treeable.model';
/**
 * Model Object for the Folder Object in dotCMS
 */
var Folder = (function (_super) {
    __extends(Folder, _super);
    function Folder() {
        var _this = _super.call(this) || this;
        _this.displayType = 'Folder';
        return _this;
    }
    return Folder;
}(Treeable));
export { Folder };
//# sourceMappingURL=folder.model.js.map